import { render, staticRenderFns } from "./workTopBack.vue?vue&type=template&id=0de4145a&scoped=true"
import script from "./workTopBack.vue?vue&type=script&lang=js"
export * from "./workTopBack.vue?vue&type=script&lang=js"
import style0 from "./workTopBack.vue?vue&type=style&index=0&id=0de4145a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de4145a",
  null
  
)

export default component.exports